import React, { useEffect, useState } from "react";

import { Button, Form, Grid, Input, theme, Typography } from "antd";
import { useUser } from "../../contexts/UserContext";

import { LockOutlined, MailOutlined } from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import { setSignUp } from "../../redux/slices/signUpSlice";
import { setSignInContent } from "../../redux/slices/signInContents";
import ErrorList from "./ErrorList";
import { FETCH_SIGN_IN } from "../../redux/actions";
import { SignIn } from "../../redux/auth/action";
import { t } from "i18next";

const { useToken } = theme;
const { useBreakpoint } = Grid;
const { Text, Title } = Typography;

const SigninForm = ({ handleSwitchPage, handleForgetPassword }) => {

    const errors = useSelector((state) => state.signInErrorMessage)


    const { token } = useToken();
    const screens = useBreakpoint();
    const { userConfigs } = useUser();
    const dispatch = useDispatch()


    const onFinish = (values) => {
        SignIn(values)
    };


    const handleSignIn = () => {
        dispatch({ type: FETCH_SIGN_IN })
    }

    const styles = {
        container: {
            margin: "0 auto",
            padding: screens.md ? `${token.paddingXL}px` : `${token.sizeXXL}px ${token.padding}px`,
            width: "380px"
        },
        footer: {
            marginTop: token.marginLG,
            textAlign: "center",
            width: "100%",
        },
        forgotPassword: {
            float: "right"
        },
        header: {
            marginBottom: token.marginXL
        },
        section: {
            alignItems: "center",
            backgroundColor: userConfigs.dark ? 'transparent' : 'white',
            display: "flex",
            height: "auto",
            width: '100%',
            padding: '0px'

        },
        text: {
            color: token.colorTextSecondary
        },
        title: {
            fontSize: screens.md ? token.fontSizeHeading2 : token.fontSizeHeading3
        }
    };


    return (
        <section style={styles.section} dir={userConfigs.locale.locale === 'fa' || userConfigs.locale.locale === 'ar' ? 'rtl' : 'ltr'}>
            <div style={styles.container}>
                <div style={styles.header}>
                    <Title style={styles.title}>{t('user.signIn')}</Title>
                </div>
                <Form
                    name="normal_login"
                    initialValues={{
                        remember: true,
                    }}
                    onFinish={onFinish}
                    layout="vertical"
                    requiredMark="optional"
                >
                    <Form.Item
                        name="email"
                        rules={[
                            {
                                type: "email",
                                required: true,
                                message: "Please input your Email!",
                            },
                        ]}
                    >
                        <Input
                            prefix={<MailOutlined />}
                            placeholder={t('user.email')}
                            style={{ padding: '10px' }}
                            autoComplete="new-email"
                        />
                    </Form.Item>
                    <Form.Item
                        name="password"
                        rules={[
                            {
                                required: true,
                                message: "Please input your Password!",
                            },
                        ]}
                    >
                        <Input.Password
                            prefix={<LockOutlined />}
                            type="password"
                            placeholder={t('user.password')}
                            style={{ padding: '10px' }}
                            autoComplete="new-password"
                        />
                    </Form.Item>
                    <ErrorList errors={errors} />
                    <Form.Item style={{ marginBottom: "0px" }}>
                        <Button block="true" type="primary" htmlType="submit" onClick={handleSignIn}>
                            {t('user.login')}
                        </Button>
                        <div style={styles.footer}>
                            <Text style={styles.text}>{t('user.Dont_have_an_account')}</Text>
                            <Button style={{ margin: '0px 8px' }} onClick={handleSwitchPage}>{t('user.signUpNow')}</Button>
                        </div>
                    </Form.Item>
                    <Form.Item style={{ marginBottom: "0px" }}>
                        <div style={styles.footer}>
                            <Text style={styles.text}>{t('user.forget_password')}</Text>
                            <Button style={{ margin: '0px 8px' }} onClick={handleForgetPassword}>{t('user.reset_password')}</Button>
                        </div>
                    </Form.Item>
                </Form>
            </div>
        </section>
    )
}

export default SigninForm
